import React from 'react';
import {
  signFromType
} from './lib/math';

const Blank = 0;
const Wrong = 1;
const Correct = 2;

export default class WorksheetProblem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      correct: this.props.correct
    };
    this.answerChange = this.answerChange.bind(this);
  }

  answerChange(ev) {
    let result;
    if (this.props.answer == ev.target.value) {
      result = Correct;
    }
    else {
      result = Wrong;
    }
    if (ev.target.value == '') {
      result = Blank;
    }
    this.props.setCorrectProblem(this.props.index, result);
    this.setState({
      value: ev.target.value
    });
  }

  correctAnswer() {
    switch(this.props.correct) {
      case Blank:
        return '';
      case Wrong:
        return ' worksheets__problem-index--wrong';
      case Correct:
        return ' worksheets__problem-index--correct';
    }
  }

  render() {
    let indexClasses = 'worksheets__problem-index';
    indexClasses += this.correctAnswer();
    const focused = this.props.index === 0;
    const index = this.props.index + 1; // Starts numbering with 1.
    const answer = this.props.correct == Blank ? '' : this.state.value;
    return(
      <div className="worksheets__problem">
        <span className={indexClasses}>{index}</span>
        <span className="worksheets__problem-top">{this.props.top}</span>
        <span className="worksheets__problem-bottom">{this.props.bottom}</span>
        <span className="worksheets__problem-sign">{signFromType(this.props.type)}</span>
        <span className="worksheets__problem-line"></span>
        <input className="worksheets__problem-answer"
          autoFocus={focused}
          onChange={this.answerChange}
          value={answer}
          type="text" />
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/worksheets/worksheet-problem.js
 **/